
import { defineComponent } from "vue";

export default defineComponent({
  name: "Blog003",

  mounted() {
    let mathjax = document.createElement("script");
    mathjax.setAttribute(
      "src",
      "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/MathJax.js?config=TeX-MML-AM_CHTML"
    );
    mathjax.setAttribute("type", "text/javascript");
    document.head.appendChild(mathjax);

    // This will call MathJax to re-render the content again.
    let mathjaxconf = document.createElement("script");
    mathjaxconf.innerHTML = 'MathJax.Hub.Queue(["Typeset",MathJax.Hub]);';
    document.head.appendChild(mathjaxconf);
  },
});
